import { call } from "../helpers/axiosInterceptor";

const getTilesList = async () => {
    const { data } = await call.get("tiles", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
    });
    return data.data;
};

const createTile = async (payload: any) => {
    const { data } = await call.post("tiles/create", payload, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
    });
    return data;
};

const updateTile = async (payload: any) => {
    if (!payload._id) throw new Error("Tile ID is required");
    const { data } = await call.post(`tiles/update`, payload, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
    });
    return data;
};

const getTileDetails = async (id: string) => {
    const { data } = await call.get(`tiles/${id}`, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
    });
    return data;
};

const deleteTile = async (tileId: string) => {
    try {
        
        const response = await call.delete(`/tiles/${tileId}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("refToken"),
            },
        });
        return response.data;
    } catch (e: any) {
        console.error("Error deleting tile:", e.response?.data?.message || e.message);
        throw e;
    }
};

export { getTilesList, createTile, updateTile, getTileDetails, deleteTile };